import { render, staticRenderFns } from "./ks2-has-issues.vue?vue&type=template&id=127f2830&lang=pug&"
import script from "./ks2-has-issues.vue?vue&type=script&lang=ts&"
export * from "./ks2-has-issues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports